module.exports = __webpack_public_path__ + "static/media/install1.3ab4379a.png";